import React from "react";
import { Button, Link, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";


import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { LoadState } from "../../../../../../../constants/enums";
import { IAutomobileDriverInformation } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import {
  clearAutomobileDriverInfo,
  fetchAutomobileDriverListAsync,
} from "../../../../../../../redux/automobileDriver/automobileDriverActions";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import { useTableV2State } from "../../../../../../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { ControlledCustomSelect } from "../../../../../../../components/formsComponents";
import { COMMON_STATUS } from "../../../../../../../constants/constants";
import { StatusRenderer } from "../../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PageTitleBar } from "../../../../../../../components/PageTitleBar/PageTitleBar";
import { AddOutlined } from "@mui/icons-material";
import { DataTableV2 } from "../../../../../../../components/TableV2/DataTableV2";
import { ImportVehicleDriverData } from "../../../PoliciesCommon/ImportVehicleDriverData/ImportVehicleDriverData";

export const AutomobileDriverInformationList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { driversList, loading } = useSelector(
    (storeState: IStoreState) => storeState.automobile.driver.driverInformation
  );
  const [openImport, setOpenImport] = React.useState(false);
  const customerInfo = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.basicDetails.customerInfo.data
  );



  const dispatch = useDispatchWrapper();

  const [status, setStatus] = React.useState<"ACTIVE" | "INACTIVE" | "-1">(
    "ACTIVE"
  );

  const {
    state: { dateState, searchState, tabs, columnsConfig,
      dense },
    setDateState,
    setSelectedTab,
    setTableTabs,
    setSearchState,
    setColumnVisibility,

    onDenseToggle, } = useTableV2State({
      filtersInitialState: {
        defaultDateRange: "allTimes",
        selectedTab: "-1",
      },
    });

  const handleCreate = () => {
    navigate(
      `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/driver-information`
    );
  };

  const fetchList = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileDriverListAsync(customerPolicyId, status));
    }
  };

  const handleComplete = () => {
    fetchList();
    setOpenImport(false);
  }

  React.useEffect(() => {
    fetchList();

    return () => {
      dispatch(clearAutomobileDriverInfo());
    };
  }, [customerPolicyId, status]);

  const automobileDriverTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <ControlledCustomSelect
                fullWidth
                value={status}
                name="status"
                onChange={(e) => setStatus(e.target.value as "ACTIVE")}
                placeholder="Select one"
                displayEmpty
                options={COMMON_STATUS}
              />
            ),
          },
        ],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverInformation) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/driver-information/${row.driver_number}`
                );
              }}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverInformation) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "driver_number",
        headerName: "#",
        fieldName: "driver_number",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
      },
      {
        key: "driver_name",
        headerName: "Driver Name",
        fieldName: "driver_name",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 30,
        onRowCellRender: (value, row) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/driver-information/${row.driver_number}`
                );
              }}
            >
              {row.driver_name}
            </Link>
          );
        },
      },

      {
        key: "date_of_birth",
        headerName: "Date of Birth",
        fieldName: "date_of_birth",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.DATE_DARK_COLOR,
      },
      {
        key: "age",
        headerName: "Age",
        fieldName: "age",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.CHIP_WARNING,
      },

      {
        key: "driver_phone_number",
        headerName: "Phone Number",
        fieldName: "driver_phone_number",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "license_number",
        headerName: "License Number",
        fieldName: "license_number",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },

      {
        key: "marital_status",
        headerName: "Marital Status",
        fieldName: "marital_status",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "hire_date",
        headerName: "Hire Date",
        fieldName: "hire_date",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "insert_ts",
        headerName: "Date Modified",
        fieldName: "insert_ts",
        renderType: DataTableV2RowRenderType.DATE_TIME,
      },
    ],
    rows: driversList,
    dense: dense,
    onDenseToggle: onDenseToggle,
  };

  return (
    <>
      <PageTitleBar
        heading="Driver Information"
        rightHeading={

          <Stack direction={'row'} spacing={1}>
            <Button
              variant="contained"
              onClick={() => setOpenImport(true)}
              startIcon={<AddOutlined />}
            >
              Import driver data
            </Button>
            <Button
              variant="contained"
              onClick={handleCreate}
              startIcon={<AddOutlined />}
            >
              Create
            </Button>
          </Stack>
        }
      />
      <DataTableV2 {...automobileDriverTableProps} />
      {openImport &&
        <ImportVehicleDriverData
          open={openImport}
          type="DRIVER"
          customer_id={customerId}
          customer_policy_id={customerPolicyId}
          customer_name={customerInfo.customer_name || ""}
          onClose={() => setOpenImport(false)}
          onComplete={handleComplete}
          policy_type="AUTO"

        />

      }
    </>
  );
};
